"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HarvestStatus = exports.StrainTypes = exports.RoomTypes = void 0;
var RoomTypes;
(function (RoomTypes) {
    RoomTypes["mother"] = "mother";
    RoomTypes["vegetation"] = "vegetation";
    RoomTypes["flower"] = "flower";
    RoomTypes["dry"] = "dry";
    RoomTypes["clone"] = "clone";
    RoomTypes["packaging"] = "packaging";
})(RoomTypes = exports.RoomTypes || (exports.RoomTypes = {}));
var StrainTypes;
(function (StrainTypes) {
    StrainTypes["indica"] = "indica";
    StrainTypes["sativa"] = "sativa";
    StrainTypes["hybrid"] = "hybrid";
})(StrainTypes = exports.StrainTypes || (exports.StrainTypes = {}));
var HarvestStatus;
(function (HarvestStatus) {
    HarvestStatus["ToDoManicure"] = "To Do Manicure";
    HarvestStatus["InProgressManicure"] = "In Progress Manicure";
    HarvestStatus["ToDoDry"] = "To Do Dry";
    HarvestStatus["InProgressDry"] = "In Progress Dry";
    HarvestStatus["ToDoTrim"] = "To Do Trim";
    HarvestStatus["InProgressTrim"] = "In Progress Trim";
    HarvestStatus["Complete"] = "Complete";
})(HarvestStatus = exports.HarvestStatus || (exports.HarvestStatus = {}));
//# sourceMappingURL=interfaces.js.map